import { type FC, type SVGProps } from 'react';
import { useTranslation } from 'react-i18next';

import Logo from '~/components/Logo';
import { socialLinks } from '~/constants/social-lnks';
import { type FooterLevelTwoDisclaimer } from '~/interfaces/HeaderFooterNavV2';

import styles from './FooterSocialsAndDisclaimer.module.css';

const SocialLink = ({
  SvgIcon,
  href,
  name




}: {SvgIcon: FC<SVGProps<SVGSVGElement>>;href: string;name: string;}) => {
  return (
    <a
      className={styles.footerSocialsLink}
      data-testid="social-link"
      href={href}
      rel="noopener noreferrer"
      target="_blank"
      title={name}>

			<SvgIcon
        aria-label={`${name} icon`}
        className={styles.footerSocialsImage} />

		</a>);

};

const shouldNotShowSocialsAndDisclaimer = (
data: FooterLevelTwoDisclaimer[]) =>
{
  return !!(
  !data.length ||
  !('type' in data[0]) ||
  data[0].type !== 'DISCLAIMER');

};

export const FooterSocialsAndDisclaimer = ({
  resourcesUrl,
  socialsAndDisclaimerData



}: {resourcesUrl: string;socialsAndDisclaimerData: FooterLevelTwoDisclaimer[];}) => {
  const { t } = useTranslation(['label']);

  if (shouldNotShowSocialsAndDisclaimer(socialsAndDisclaimerData)) return null;

  return (
    <section
      aria-label="Footer Socials And Disclaimer Section"
      className={styles.footerSocialsAndDisclaimerWrapper}
      data-testid="footer-socials-and-disclaimer-section">

			<div className={styles.footerSocialsAndDisclaimerContainer}>
				<div className={styles.footerLogoContainer}>
					<a
            data-testid="logo-link"
            href="./"
            rel="noopener noreferrer"
            target="_blank"
            title="Oddschecker">

						<Logo resourcesUrl={resourcesUrl} />
					</a>
				</div>
				<div
          className={styles.footerRegulationContainer}
          data-testid="disclaimer">

					<span className={styles.legalAge}>{t('CX_LEGAL_AGE')}</span>
					{t('RESPONSIVE_FOOTER_LEGAL')}
				</div>
				<div className={styles.footerSocialsContainer} data-testid="socials">
					{socialLinks.map(({ SvgIcon, linkLabel, name }) => {
            return (
              <SocialLink
                SvgIcon={SvgIcon}
                href={t(linkLabel)}
                key={name}
                name={name} />);


          })}
				</div>
			</div>
		</section>);

};